import React from 'react';

import Quote from 'containers/user/learn/components/quote/quote';
import Callout from 'containers/user/learn/components/callout/callout';
import Paragraph from 'containers/user/learn/components/paragraph/paragraph';
import ImageComponent from 'containers/user/learn/components/img-component/img-component';
import VideoComponent from 'containers/user/learn/components/video-component/video-component';
import VimeoComponent from 'containers/user/learn/components/vimeo-component/vimeo-component';
import UploadButton from 'containers/user/learn/components/upload-button/upload-button';

interface MediaSource {
  data?: {
    attributes?: {
      url?: string;
      height?: number;
      width?: number;
      alternativeText?: string;
    };
  };
}

interface UploadFile {
  data?: { attributes?: { name?: string; url?: string } };
}

interface ContentBlock {
  id: string | number;
  type: string;
  text?: string;
  variant?: string;
  title?: string;
  author?: string;
  videoSrc?: MediaSource;
  imageSrc?: MediaSource;
  file?: UploadFile;
  btnText?: string;
  key?: React.Key;
  vimeoLink?: string;
}

export const getBlocksFromContent = ({
  id,
  type,
  text,
  variant = '',
  title = '',
  author = '',
  videoSrc = {},
  imageSrc = {},
  file,
  btnText,
  key,
  vimeoLink,
}: ContentBlock): React.JSX.Element | undefined => {
  switch (type) {
    case 'quote':
      return <Quote key={key} {...{ text, author }} />;
    case 'callout':
      return <Callout key={key} {...{ text, variant }} />;
    case 'paragraph':
      return <Paragraph key={key} {...{ id, text, title }} />;
    case 'image':
      return (
        <ImageComponent
          key={key}
          src={imageSrc?.data?.attributes?.url}
          height={imageSrc?.data?.attributes?.height as number}
          width={imageSrc?.data?.attributes?.width as number}
          alt={imageSrc?.data?.attributes?.alternativeText || title || ''}
        />
      );
    case 'video':
      return <VideoComponent key={key} src={videoSrc?.data?.attributes?.url} />;
    case 'vimeoVideo':
      return <VimeoComponent key={key} vimeoLink={vimeoLink} />;
    case 'uploadButton':
      return <UploadButton key={key} label={btnText} file={file} />;
    default:
      return undefined;
  }
};
